/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ---------------------------------------------------------------------------
   Order Trailer Parts - accessibility patches (WCAG 2.1 AA)

   1. Carousels (slideshow, product rows, recommendations) mark off-screen
      slides aria-hidden="true" but leave their links keyboard focusable, so
      keyboard users tab into links they cannot see. We mirror the native
      `inert` behaviour: anything inside an aria-hidden container is taken out
      of the tab order, and put back when it becomes visible again.

   2. A few elements carry aria-expanded even though their role does not allow
      it (the header cart link, the collection "read more" toggle), which makes
      screen readers announce a state that is not real. Those are stripped.
--------------------------------------------------------------------------- */
(function () {
  if (window.__otpA11yInit) { return; }
  window.__otpA11yInit = true;

  var FOCUSABLE = 'a[href],button,input,select,textarea,iframe,[tabindex]';

  function park(el) {
    if (el.hasAttribute('data-otp-tabindex') || el.getAttribute('tabindex') === '-1') { return; }
    el.setAttribute('data-otp-tabindex', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
    el.setAttribute('tabindex', '-1');
  }

  function hideFromTabOrder() {
    var hidden = document.querySelectorAll('[aria-hidden="true"]');
    for (var i = 0; i < hidden.length; i++) {
      /* the hidden element itself can be a link, as the slideshow slides are */
      if (hidden[i].matches(FOCUSABLE)) { park(hidden[i]); }
      var kids = hidden[i].querySelectorAll(FOCUSABLE);
      for (var j = 0; j < kids.length; j++) { park(kids[j]); }
    }
  }

  function restoreTabOrder() {
    var parked = document.querySelectorAll('[data-otp-tabindex]');
    for (var i = 0; i < parked.length; i++) {
      var el = parked[i];
      if (el.closest('[aria-hidden="true"]')) { continue; }
      if (el.getAttribute('aria-hidden') === 'true') { continue; }
      var prev = el.getAttribute('data-otp-tabindex');
      if (prev === '') { el.removeAttribute('tabindex'); } else { el.setAttribute('tabindex', prev); }
      el.removeAttribute('data-otp-tabindex');
    }
  }

  function dropUnsupportedAriaExpanded() {
    var nodes = document.querySelectorAll('a[aria-expanded]:not([role]),div[aria-expanded]:not([role]),span[aria-expanded]:not([role])');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].removeAttribute('aria-expanded');
    }
  }

  var pending = null;
  function run() {
    pending = null;
    hideFromTabOrder();
    restoreTabOrder();
    dropUnsupportedAriaExpanded();
  }
  function schedule() {
    if (pending) { return; }
    pending = window.setTimeout(run, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', schedule);

  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'aria-expanded']
    });
  }
})();


/* ---------------------------------------------------------------------------
   3. The cart page's order-note textarea ships with no label, no aria-label
      and no placeholder, so a screen reader announces only "edit text, blank".
      The visible "Order instructions" heading above it is not programmatically
      associated with the field, so we attach the name directly.
--------------------------------------------------------------------------- */
(function () {
  if (window.__otpNoteLabelInit) { return; }
  window.__otpNoteLabelInit = true;

  var NOTE_LABEL = 'Order instructions';

  function needsName(el) {
    if (el.getAttribute('aria-label')) { return false; }
    if (el.getAttribute('aria-labelledby')) { return false; }
    if (el.id && document.querySelector('label[for="' + el.id + '"]')) { return false; }
    if (el.closest('label')) { return false; }
    if (el.getAttribute('placeholder')) { return false; }
    if (el.getAttribute('title')) { return false; }
    return true;
  }

  function labelNoteFields() {
    var fields = document.querySelectorAll('textarea[name="note"],textarea[name="attributes[note]"]');
    for (var i = 0; i < fields.length; i++) {
      if (needsName(fields[i])) { fields[i].setAttribute('aria-label', NOTE_LABEL); }
    }
  }

  var pending = null;
  function schedule() {
    if (pending) { return; }
    pending = window.setTimeout(function () { pending = null; labelNoteFields(); }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelNoteFields);
  } else {
    labelNoteFields();
  }
  window.addEventListener('load', schedule);
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('product:added', schedule);

  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { subtree: true, childList: true });
  }
})();
